var _defs, _rect, _rect2, _rect3, _rect4, _line, _line2, _path, _path2, _text, _text2, _text3, _circle, _circle2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditCardGeneric({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 139,
    viewBox: "0 0 240 139",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "cardGrad",
    x1: 0,
    y1: 0,
    x2: 240,
    y2: 139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#1863CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0E3A80"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 240,
    height: 139,
    rx: 10,
    fill: "url(#cardGrad)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 240,
    height: 60,
    rx: 10,
    fill: "white",
    opacity: 0.05
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 44,
    width: 34,
    height: 26,
    rx: 5,
    fill: "#D4AF37"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 44,
    width: 34,
    height: 26,
    rx: 5,
    stroke: "#B89010",
    strokeWidth: 0.8,
    fill: "none"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 57,
    x2: 54,
    y2: 57,
    stroke: "#B89010",
    strokeWidth: 0.8
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 37,
    y1: 44,
    x2: 37,
    y2: 70,
    stroke: "#B89010",
    strokeWidth: 0.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68 50 Q74 57 68 64",
    stroke: "white",
    strokeWidth: 1.5,
    fill: "none",
    opacity: 0.7,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73 46 Q83 57 73 68",
    stroke: "white",
    strokeWidth: 1.5,
    fill: "none",
    opacity: 0.55,
    strokeLinecap: "round"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 20,
    y: 105,
    fontFamily: "'Courier New', monospace",
    fontSize: 16,
    fill: "white",
    opacity: 0.85,
    letterSpacing: 2
  }, "\u2022\u2022\u2022\u2022 \u2022\u2022\u2022\u2022 \u2022\u2022\u2022\u2022 \u2022\u2022\u2022\u2022")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 20,
    y: 124,
    fontFamily: "'Red Hat Text', sans-serif",
    fontSize: 9,
    fill: "white",
    opacity: 0.6,
    letterSpacing: 0.5
  }, "VALID THRU")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 20,
    y: 134,
    fontFamily: "'Courier New', monospace",
    fontSize: 11,
    fill: "white",
    opacity: 0.85
  }, "MM / YY")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 208,
    cy: 24,
    r: 14,
    fill: "#EB001B",
    opacity: 0.88
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 224,
    cy: 24,
    r: 14,
    fill: "#F79E1B",
    opacity: 0.88
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M216 14 Q222 24 216 34",
    fill: "#FF5F00",
    opacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCardGeneric);
export default __webpack_public_path__ + "static/media/credit-card-generic.b344e33a31ad5c327b8835a569cc6ad6.svg";
export { ForwardRef as ReactComponent };